import React from 'react';
import { HiChevronLeft } from 'react-icons/hi';
import Footer from './footer';

function View360() {
  return (
    <div className="min-h-screen bg-[#fdf4e4] text-[#3f3a32] px-4 py-6 flex flex-col items-center">
      
      {/* Go Back */}
      <a href="/" className="flex items-center text-[#3f3a32] font-semibold text-base mb-4 hover:underline">
        <HiChevronLeft className="text-lg" />
        Go back
      </a>

      {/* 360 VR Frame */}
      <div className="w-full max-w-5xl h-[400px] md:h-[600px] rounded-xl overflow-hidden shadow-lg border border-[#e0d4b9]">
  <iframe
    title="Sigiriya VR 360 View"
    width="100%"
    height="100%"
    frameBorder="0"
    allow="xr-spatial-tracking; gyroscope; accelerometer"
    allowFullScreen
    scrolling="no"
    src="https://kuula.co/share/h9BGP?logo=1&info=1&fs=1&vr=0&sd=1&thumbs=1"
  ></iframe>
</div>

<Footer />

    </div>
  );
}

export default View360;
